export default __webpack_public_path__ + "static/media/case_study_card_desktop.304aee04.svg";